export const numberFormatter = new Intl.NumberFormat('en-US');

// formatter.format(2500); /* $2,500.00 */
